<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <router-link tag="button" :to="{name: 'fuels.create'}" class="btn btn-info">
                    <span class="btn-label">
                        <i class="material-icons">add</i>
                    </span>
                    Novo
                </router-link>
            </div>
        </div>
        <br />
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header card-header-icon card-header-rose">
                        <div class="card-icon">
                            <i class="material-icons">list</i>
                        </div>
                        <h4 class="card-title ">Lista</h4>
                    </div>
                    <div class="card-body">
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th class="text-center">#</th>
                                        <th>Nome</th>
                                        <th class="text-right">Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr 
                                        v-show="items.length > 0"
                                        v-for="iterator in items" 
                                        :key="iterator.id">
                                        <td class="text-center">{{ iterator.id }}</td>
                                        <td>{{ iterator.name }}</td>
                                        <td class="td-actions text-right">
                                            <index-buttons
                                                :iterator=iterator
                                                :showAudit="false"
                                                :toAudit="{name: 'dashboard'}"
                                                :showEdit="true"
                                                :toEdit="{name: 'fuels.edit', params: { id: iterator.id }}"
                                                :showRemove="true"
                                                dispatchRemove="fuels/rem"
                                                :callbackRemove="getData"
                                                >
                                            </index-buttons>
                                        </td>
                                </tr>
                                <tr v-show="items.length==0">
                                    <td colspan="3">Nenhum combustível encontrado!</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
    export default {
        computed: {
            items: {
                set(_fuels) {

                },
                get() {
                    return this.$store.state.fuels.itens;
                }
            }
        },
        created: function () {
            this.items = [];
            this.getData();
        },
        data() {
            return {
                currentPage: 1
            };
        },
        methods: {
            remove: function (_item) {
                var self = this;
                this.$dialog.confirm('Deseja realmente remover o combustível "' + _item.name + '"?')
                        .then(function () {
                            self.$root.$emit('onLoading');

                            const response = self.$store.dispatch('fuels/rem', _item);

                            response.then(function () {
                                self.$root.$emit('onLoading');
                                self.$notify.success("Combustível excluído com sucesso!");
                                self.getData();
                            });

                            response.catch(function () {
                                self.$root.$emit('onLoading');
                                self.$notify.danger("Não foi possível excluir o combustível!");
                            });
                        });
            },
            async getData() {
                var self = this;

                self.$root.$emit('onLoading');
                const response = self.$store.dispatch('fuels/all');

                response.then(function () {
                    self.$root.$emit('onLoading');
                });

                response.catch(function () {
                    self.$root.$emit('onLoading');
                });
            }
        }
    }
</script>